import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface Props {
  rotulo: string;
  titulo: ReactNode;
  texto: string;
}

export function Heroi({ rotulo, titulo, texto }: Props) {
  return (
    <section className="lp-heroi">
      <div className="lp-brilhos" aria-hidden>
        <span className="lp-brilho lp-brilho-a" />
        <span className="lp-brilho lp-brilho-b" />
        <span className="lp-faisca lp-faisca-1" />
        <span className="lp-faisca lp-faisca-2" />
        <span className="lp-faisca lp-faisca-3" />
      </div>

      <p className="lp-rotulo lp-rotulo-ponto lp-entra">{rotulo}</p>

      <h1 className="lp-heroi-titulo lp-entra lp-atraso-1">{titulo}</h1>

      <p className="lp-heroi-texto lp-entra lp-atraso-2">{texto}</p>

      <div className="lp-heroi-acoes lp-entra lp-atraso-3">
        <Link to="/criar-conta" className="lp-btn lp-btn-principal">
          Criar conta
        </Link>
        <Link to="/entrar" className="lp-btn lp-btn-secundario">
          Já sou cliente
        </Link>
      </div>

      <p className="lp-heroi-nota lp-entra lp-atraso-4">
        Conecta no seu número atual, lendo um QR code.
      </p>
    </section>
  );
}
